import { InjectionToken } from '@angular/core';
import type { SidenavV2Component } from './sidenav-v2.component';

/**
 * Contrôleur de la sidenav, injecté par son composant de rendu
 * (sidenav-cafe). Toute la logique (navigation, projets, dossiers favoris,
 * actions rapides, organisations, profil) vit dans SidenavV2Component ; le
 * rendu ne fait que l'agencer.
 *
 * Jeton plutôt qu'injection directe de la classe : évite l'import circulaire
 * contrôleur ↔ rendu.
 */
export const SIDENAV = new InjectionToken<SidenavV2Component>('SIDENAV');
